// removed by extract-text-webpack-plugin
module.exports = {"mainImgWrap":"_1FBd0FRgCZC1R4COTGbEtl","mainImg":"_3jLrnslbZI9udapDqCRiMA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainGraphics/MainGraphics.css
// module id = 45
// module chunks = 0